module.exports = __webpack_public_path__ + "static/img/cloud-4.c04e613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/cloud-4.png
// module id = Mw/d
// module chunks = 0